import { createApi } from '@reduxjs/toolkit/query/react'

import { rtkBaseQuery } from '../../../../api'

export const appsApi = createApi({
  baseQuery: rtkBaseQuery,
  reducerPath: 'appsApi',
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    getAllApps: builder.query({
      query: () => '/v1/apps/'
    })
  })
})

export const { useGetAllAppsQuery } = appsApi

export default appsApi
